import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { AudioPlayerDataType } from '@/modules/types/audioPlayer';

export const audioPlayerAdaptor = createEntityAdapter();

const initialState: AudioPlayerDataType = audioPlayerAdaptor.getInitialState({
  loaded: false,
  mute: true,
  playing: false,
  source: '',
  howler: null,
});

const audioPlayerSlice = createSlice({
  name: 'audioPlayer',
  initialState,
  reducers: {
    playPauseAudio: (state, action) => {
      state.loaded = true;
      state.mute = false;
      state.entity = action.payload.entity ? action.payload.entity : '';
      if (
        action.payload.source !== '' &&
        state.source !== action.payload.source
      ) {
        state.playing = true;
      } else {
        state.playing = !state.playing;
      }
      state.source = action.payload.source;
    },
    stopAudio: (state) => {
      state.playing = false;
      state.source = '';
    },
    endAudio: (state) => {
      state.loaded = false;
      state.playing = false;
      state.howler = null;
    },
    loadAudio: (state, action) => {
      state.howler = action.payload;
    },
    seekAudio: (state, action) => {
      state.howler.seek(action.payload);
    },
    setAudioVolume: (state, action) => {
      state.howler.volume(action.payload);
    },
  },
});

export const { name, actions, reducer } = audioPlayerSlice;
